import R from 'ramda';
import moment from 'moment';
import {
  shouldShowModal as getShouldShowModal,
  getInterval,
  getMainSteps,
} from 'ha/modules/ActivationModal/selectors';
import { getFromStorage, setInStorage } from 'ha/utils/storage';
import { open } from 'ha/modules/ModalsLogic/actions';
import { openDelay } from 'ha/modules/ActivationModal/constants';

function showModalAndTrackTime(dispatch) {
  setInStorage('activationModalLastShown', moment().valueOf());

  return setTimeout(() => dispatch(open('activation-modal')), openDelay);
}

const handleOpen = ({ store, action: { payload } }) => {
  const { dispatch, getState } = store;

  const shouldShowModal =
    getShouldShowModal(getState()) || payload.showSuccessStep;

  if (!shouldShowModal) {
    return true;
  }

  const lastShown = +getFromStorage('activationModalLastShown');

  const timeSinceLastShow = moment().diff(lastShown);

  const interval = getInterval(getState());

  if (
    (payload.showSuccessStep &&
      !R.without('confirmation', getMainSteps(getState())).length) ||
    !lastShown ||
    timeSinceLastShow >= interval
  ) {
    return showModalAndTrackTime(dispatch);
  }

  if (timeSinceLastShow < interval) {
    setTimeout(
      () => showModalAndTrackTime(dispatch),
      interval - timeSinceLastShow,
    );
  }

  return true;
};

export default handleOpen;
